import chatStoreManager from '@/store/chat/manager';
import { useNavigate } from 'react-router-dom';
import userStore from '@/store/user';
import { SVGPureIcon } from '@/ui';
import { observer } from 'mobx-react-lite';
import globalStore from '@/store/global';
import Login from '@/components/header/login';
import urlStore from '@/store/chat/urlStore';
import EE from '@/common/event';
import client from '@/store/client';
import { useEffect, useRef, useState } from 'react';
import { useAsyncEffect } from 'ahooks/lib';
import FoldBtn from '@/ui/fold-btn';
import AagentMenu from '@/pages/agent-home/components/agent-menu';
import ShareConversationBtn from "./share-conversation-btn";
import AgentShare from '@/pages/agent-home/components/agent-share-qrcode';
import Other from '@/common/helper/other';
import copyShareStore, {SHARE_INFO_MAP,SHARE_STATUS_MAP} from './share-conversation-btn/store';
import Loader from '@/common/helper/loader';
import useIsAiso from '@/hooks/useIsAiso';

function HeaderMenu(props) {
  const chatStore = chatStoreManager.current;
  const { conversation_id, widthChat, showRightPanel } = props;
  const [isAddedKb, setIsAddedKb] = useState(null) // 是否已加入知识库
  const [loading, setLoading] = useState(false) // 是否已加入知识库
  const [shareUrl, setShareUrl] = useState('')
  const nivagate = useNavigate();
  const isAiso = useIsAiso();

  const modalRef = useRef(null);
  const checkingRef = useRef(null);

  let small = widthChat < Loader.size.chatSmall;
  if (showRightPanel) {
    small = widthChat < Loader.size.chatSmall * 1.4;
  }

  const isMcpServer = chatStoreManager.current.lastMessage?.cloud_mcp?.length > 0 || chatStoreManager.current.lastMessage?.mcp?.length > 0;
  const { isMcpAgent, isAgentFlow } = chatStoreManager.current.mcpStore;

  useAsyncEffect(async ()=>{
    if(!conversation_id || !userStore.uid) return setIsAddedKb(null)
    return () => {
    }
  }, [conversation_id, userStore.uid])


  useEffect(() => {
    if(
      !chatStoreManager.current.chatId
      || (!isMcpAgent && !isAgentFlow)
    ){
      return;
    }

    copyShareStore.getShareStatus();
  }, [isMcpAgent, isAgentFlow, chatStoreManager.current.chatId])

  useEffect(() => {
    if(copyShareStore.shareStatus === SHARE_STATUS_MAP.SHARE_CHECKING){
      checkingRef.current = setInterval(() => {
        copyShareStore.getShareStatus();
      }, 15000);
    }else if(checkingRef.current){
      clearInterval(checkingRef.current);
      checkingRef.current = null;
    }

    return () => {
      if(checkingRef.current){
        clearInterval(checkingRef.current);
        checkingRef.current = null;
      }
    };
  }, [copyShareStore.shareStatus]);

  const { successToast, icon, text } = SHARE_INFO_MAP[copyShareStore.shareStatus];

  const handleShareStatus = () => {
    switch (copyShareStore.shareStatus) {
      case SHARE_STATUS_MAP.NOT_SHARE: { // 未分享
        modalRef.current = Other.confirm({
          title: '您确定要发布吗?',
          content: '发布后，此案例将对所有人展示',
          closable: false,
          onOk: () => {
            copyShareStore.shareToSquare( 1 );
          },
        });
        break;
      }
      case SHARE_STATUS_MAP.SHARE_CHECKING: { // 分享审核中
        modalRef.current = Other.confirm({
          title: '您确定要取消发布吗?',
          content: '取消后，此案例将取消对所有人展示',
          closable: false,
          onOk: () => {
            copyShareStore.shareToSquare( 0 );
          },
        });
        break;
      }
      case SHARE_STATUS_MAP.SHARE_OPEN: {// 分享开放中
        modalRef.current = Other.confirm({
          title: '您确定要取消发布吗?',
          content: '取消后，此案例将取消对所有人展示',
          closable: false,
          onOk: () => {
            copyShareStore.shareToSquare( 0 );
          },
        });
        break;
      }
      case SHARE_STATUS_MAP.SHARE_DISABLE: { // 分享禁用
        modalRef.current = Other.confirm({
          title: '您确定要发布吗?',
          content: '发布后，此案例将对所有人展示',
          closable: false,
          onOk: () => {
            copyShareStore.shareToSquare( 1 );
          },
        });
        break;
      }
      default:
        console.warn('未知的分享状态:', copyShareStore.shareStatus);
        break;
    }
  }

  useEffect(() => {
    if(chatStore.isAITyping){
      return;
    }
  }, [chatStore.isAITyping, chatStoreManager.current.chatId])

  useEffect(() => {
    return () => {
      // 关闭弹窗
      modalRef.current && modalRef.current.destroy();
      modalRef.current = null;
    }
  }, []);

  return (
    <div className="flex w-1/2 justify-end items-center bg-white">
      {
        showRightPanel ? <div className="text-18px font-bold flex-grow pl-45px">智能体工作过程</div> : null
      }
      {
        showRightPanel && !chatStore.isAITyping && !userStore.isBrand
        ? (
          <FoldBtn
            onClick={handleShareStatus}
            text={text}
            tips={successToast + (copyShareStore.statusMsg ? `${copyShareStore.statusMsg}` : '')}
            iconName={icon}
            className="!h-32px !mr-12px"
            small={small}
            circle
          />
        )
        : null
      }
      {
        isAiso || userStore.isBrand
        ? null
        : (
          <FoldBtn
            onClick={evt => {
              if(chatStore.mcpStore.isAgent){
                nivagate('/tools/aiagent/chat/' + (chatStore.aiAgentId || chatStore.aiAgentFlowId))
              }
              else {
                urlStore.newChat({ roleId : chatStore.currAsstId, agentId : chatStore.agentId });
              }
              EE.emit("chat_input_focus");
              chatStore.log({
                action: 'click',
                set: 'new_chat',
              });
            }}
            text="新对话"
            iconName="chat_new_conversation"
            className="!h-32px !mr-12px"
            small={small}
            circle
          />
        )
      }

      {/* 分享对话 */}
      {
        !chatStore.isAITyping && chatStore.chatId && !isMcpAgent
        ? (
          <ShareConversationBtn small={small} chatStore={chatStore} />
        )
        : null
      }
      {
        !chatStore.isAITyping && !userStore.isBrand &&
        ((
          chatStore.mcpStore?.agentInfo?.visitable == 1 &&
          isMcpAgent
        ) ||
        isMcpServer)
        ? (
          <div className='mr-12px'>
            <AgentShare
                small={small}
                circle
                shareUrl={shareUrl}
              />
          </div>
        )
        : null
      }
      {
        userStore.isVip && globalStore.globalConfig.supportTheme
        ? (
          <div
          className={[
            'w-32px h-[32px] rounded-[16px] flex box-border justify-center',
            'border-[1px] border-solid border-black-10 items-center',
            'z-20 mr-[16px]  header-history-btn cursor-pointer',
            'bg-button-bg-normal hover:bg-button-bg-hover hover:border-none',
            {'border-none': globalStore.isDark}
          ]}
          onClick={globalStore.toggleTheme}
        >
          <SVGPureIcon
            className="w-[16px] h-[16px]"
            name={`comp-${globalStore.isDark ? "light" : "dark"}`}
          />
        </div>
        )
        : null
      }
      {userStore.isUser && !userStore.isBrand &&
      chatStore.mcpStore?.agentInfo?.creator_qid == userStore.uid &&
      !chatStore.isAITyping ? (
        <AagentMenu
          item={chatStore.mcpStore?.agentInfo}
          deleteCallback={evt => {
            globalStore.gotoAgentHome();
          }}
          className="size-32px border-1px border-[rgba(0,0,0,0.1)] rounded-full overflow-hidden"
          scene="chat"
        />
      ) : null}
      {
        !(!client.isClient && !client.isLLQ)
        ? <Login />
        : null
      }

    </div>
  );
}

export default observer(HeaderMenu);
